import React from 'react';
import { useQuery } from '@apollo/client';
import {
  CircularProgress, FormControlLabel, Radio, RadioGroup, Typography,
} from '@mui/material';
import { Control } from 'react-hook-form';
import { GET_AWO_USERS } from '../../queries';
import { AwoUser } from '../../types/Awo';
import { RadioControl } from '../FormControls';

function PrimaryAdminPartial(
  { control, awoId }: { control: Control<any, any>, awoId: number },
) {
  const { data, loading } = useQuery<{ awoUsers: AwoUser[] }>(GET_AWO_USERS, {
    variables: { awoId },
  });

  if (loading) {
    return <CircularProgress size={24} />;
  }

  const members = data?.awoUsers ?? [];
  if (members.length === 0) {
    return (
      <Typography variant="body2" color="secondary.text">
        This organization has no members yet. Invite a member before selecting a primary admin.
      </Typography>
    );
  }

  return (
    <RadioControl
      fieldName="primaryAdminId"
      control={control}
      render={({ onChange, value, ...props }) => (
        <RadioGroup
          {...props}
          value={value ?? ''}
          onChange={(event, newValue) => onChange({ target: { name: 'primaryAdminId', value: newValue } })}
        >
          {members.map((member) => (
            <FormControlLabel
              key={member.id}
              value={String(member.id)}
              control={<Radio />}
              label={`${member.firstName} ${member.lastName} (${member.email})`}
            />
          ))}
        </RadioGroup>
      )}
    />
  );
}
export default PrimaryAdminPartial;
